import { Navigate, createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { useMerchantProvider } from "@/app/(authenticated)/_providers/merchant-provider.tsx";

const searchSchema = z.object({
  callbackUrl: z.string().optional(),
});

export const Route = createFileRoute("/(authenticated)/")({
  component: RouteComponent,
  validateSearch: (search) => searchSchema.parse(search),
});

function RouteComponent() {
  const { callbackUrl } = Route.useSearch();

  const { selectedMerchant } = useMerchantProvider();

  if (callbackUrl) return <Navigate to={callbackUrl} replace={true} />;

  if (!selectedMerchant?.merchAccountId) return null;

  return (
    <Navigate
      to={"/$merchantId/transactions"}
      params={{
        merchantId: selectedMerchant.merchAccountId,
      }}
      replace={true}
    />
  );
}
